export const trimToDecimals = (num: number, decimals: number = 2): number => {
  return Number(num.toFixed(decimals));
};
